import { Injectable, Inject } from 'ng-metadata/core';
import { getVid } from '../../appConfig/appConfigForward';
import { MediaQueries } from '../../infra/mediaQueries.service';
import { SharedSessionStorage } from '../../infra/sharedSessionStorage.service';
import { MappingTablesCache } from '../../mappingTablesCache/mappingTablesCache.service';
import { UserSessionManagerService } from '../../security/userSessionManager.service';


@Injectable()
export class FavoritesWarningMessageService{
    private ENABLE_SAVEESHELF_MESSAGE: string = "enable_saveEshelf_message";
    private SESSION_KEY: string = "showFavoritesWarning";
    private _currentState: string;
    private _currentRecord: string;
    private fulldisplay_list = ['/fulldisplay','/jfulldisplay','/dbfulldisplay','/npfulldisplay'];
   
    constructor(
        @Inject('$timeout') private $timeout: ng.ITimeoutService,
        @Inject('$state') public $state: ng.ui.IStateService, 
        @Inject('$location') private $location: ng.ILocationService,
        @Inject('$mdToast') private $mdToast: ng.material.IToastService,
        private mappingTablesCache: MappingTablesCache,
        private mediaQueries: MediaQueries, 
        private sharedSessionStorage: SharedSessionStorage,
        private userSessionManagerService: UserSessionManagerService) {
        
    }

    public isFavoritesWarningEnabledInMT() {            //is enabled in 'View Properties' MT
        return this.mappingTablesCache.findByProperties(this.mappingTablesCache.tables.VIEW_PROPERTIES,
            {source1: getVid(), source2: this.ENABLE_SAVEESHELF_MESSAGE, target: 'true'}).length > 0;
    }

    public isDisplayFavoritesWarning() {         //checked by the ng-if in the 2 warning locations: search-bookmark-filter.html & save-to-favorites-button.html
        return this.isDisplay() && !this.isHideAfterStateChange() && !this.isHideAfterFullViewNavigation() && this.userSessionManagerService.isGuest();
    }

    public isDisplay(){
        return this.sharedSessionStorage.getItem(this.SESSION_KEY) === 'true' ? true : false; 
    }

    public isDismissedDuringSession(){
        return this.sharedSessionStorage.getItem(this.SESSION_KEY) === 'false' ? true : false; 
    }

    public closeButton(){
        this.sharedSessionStorage.setItem(this.SESSION_KEY, 'false');
    }

    public onDismiss(byUser){ 
        this.$mdToast.hide();
        //The Following code fixes a bug with mdToast who places "position: relative" on root element but doesn't remove it once it is closed. 
        //This causes md-dialog to not display correctly.
        this.$timeout(() => { 
            let elem = document.querySelector("primo-explore");
            if (elem) {
                angular.element(elem).css('position', '');
            }
            if (byUser){                //dismissing future appreances only if it closed by the user
                    this.closeButton();
            }
        }, 0);
    }

    public onDismissByUser(){
        this.onDismiss(true);
    }

    public onDismissByMenu(){
        this.onDismiss(false);
    }

    public hideFavoritesWarningForGuestsByMenu(){
        if (this.isDisplay()){
            this.sharedSessionStorage.removeItem('showFavoritesWarning');
            if (!this.mediaQueries.gtsm){
                this.onDismissByMenu();
            }
        }
    }

    public isHideAfterStateChange(){             //when changing state the message should disappear
        if (!this.currentState){                //in a refresh scenario the currentState is undefined
            this.sharedSessionStorage.removeItem(this.SESSION_KEY);
        }
        else if (this.currentState !== this.$location.path()){
            if (this.mediaQueries.gtsm){ //desktop or horizontal iPad
                this.closeButton(); 
            }
            else{                       //mobile or vertical iPad - we should also hide the toast properly
                this.onDismissByUser();
            }
            return true;
        }
        return false;
    }

    public isHideAfterFullViewNavigation(){             //when navigating in full view the message should disappear
        if (this.fulldisplay_list.indexOf(this.currentState)>=0 && this.currentRecord != this.$location.search().docid){
            if (this.mediaQueries.gtsm){ //desktop or horizontal iPad
                this.closeButton(); 
            }
            else{                       //mobile or vertical iPad - we should also hide the toast properly
                this.onDismissByUser();
            }
            return true;
        }
        return false;
    }

    public showMessage(){               //This function is called after pin button was clicked
        this.currentState = this.$location.path();
        if (this.fulldisplay_list.indexOf(this.currentState)>=0){
            this.currentRecord = this.$location.search().docid;
        }
        if (this.isFavoritesWarningEnabledInMT() && !this.isDismissedDuringSession() && this.userSessionManagerService.isGuest()){
            if (this.mediaQueries.gtsm){
                this.$timeout(() => {       //to make the message appear after the pin animation
                    this.sharedSessionStorage.setItem(this.SESSION_KEY, 'true');
                },1000)
            }
            else{                       //mobile or vertical iPad
               this.sharedSessionStorage.setItem(this.SESSION_KEY, 'true');
                this.showToast();
            }  
        }
    }

    public showToast(){                         //This function is called after pin button was clicked in Mobile
         if (this.isDisplayFavoritesWarning()){
            let templateString = "<prm-favorites-warning-message></prm-favorites-warning-message>";
            this.$mdToast.show({
                hideDelay: 0,
                position: 'bottom right',
                template: templateString
            })
        }
     }

     public isDisplayToast(){
        return (this.mediaQueries.xs || this.mediaQueries.sm) && this.isDisplayFavoritesWarning();
     }

    get currentState() {
        return this._currentState;
    }

    set currentState(value) {
        this._currentState = value;
    }

    get currentRecord() {
        return this._currentRecord
    }

    set currentRecord(value) {
        this._currentRecord = value;
    }
}


// WEBPACK FOOTER //
// ./src/main/webapp/components/favorites/favoritesWarningMessage/favoritesWarningMessage.service.ts